module.exports = __webpack_public_path__ + "img/google.4e6e9cec.svg";